import { Slider, SliderProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ThumbComponent } from './thumb';

type StylesProps = {
	railBackground: string;
}

const useStyles = makeStyles<StylesProps>({ name: 'RangeSlider' })((theme, { railBackground }) => ({
	rail: {
		background: railBackground,
		opacity: 1
	},
	track: {
		display: 'none'
	}
}));

export type SkodaSliderProps = Omit<SliderProps, 'min' | 'max' | 'value' | 'onChange' | 'onChangeCommitted'> & {
	min: number;
	max: number;
	value: number | number[];
	onChange?: (value: number | number[]) => void;
	onChangeCommitted?: (value: number | number[]) => void;
	colors?: string[];
};

export const SkodaSlider: React.FC<SkodaSliderProps> = (props) => {
	const { colors, onChange, onChangeCommitted, classes, ...other } = props;

	const theme = useTheme();
	const railColors = colors ?? theme.Skoda?.settings?.skodaSlider?.colors;

	const railBackground = useMemo(() =>
		getRailGradient(props.min, props.max, props.value, railColors),
		[props.min, props.max, props.value, railColors]);

	const { classes: styles } = useStyles({ railBackground }, { props });

	return <Slider
		onChange={(_, val) => onChange?.(val)}
		onChangeCommitted={(_, val) => onChangeCommitted?.(val)}
		components={{ Thumb: ThumbComponent }}
		classes={{ ...styles }}
		{...other} />;
};

const getRailGradient = (min: number, max: number, value: number | number[], colors: string[]) => {
	const valuesArr = Array.isArray(value) ? value : [value];
	const range = max - min;
	const percentages = valuesArr.map(val => (val - min) / range);
	const postions = percentages.map(perc => `calc(${perc * 100}% + (${40 * (0.5 - perc)}px))`);
	return `linear-gradient(to right,${getGradientFragments(colors, postions)})`;
};

const getGradientFragments = (c: string[], p: string[]) => {
	let res = `${c[0]} 0%`;
	for (let i = 0; i < p.length; i++) {
		res += `, ${c[i]} ${p[i]}, ${c[i + 1]} ${p[i]}`;
	}
	return res;
};
